// import { useQueries } from "@tanstack/react-query";
// import { offerServices } from "features/offer/services/offer.service";

// export const useOffers = (params) => {
//     return useQueries({
//         queries: [
//             {
//                 queryKey: ["offers", params],
//                 queryFn: () => offerServices.getOffers(params),
//                 staleTime: 5 * 60 * 1000,
//                 gcTime: 10 * 60 * 1000,
//                 keepPreviousData: true,
//             }
//         ]
//     });
// };

// export const useOffer = (offerId) => {
//     return useQueries({
//         queries: [
//             {
//                 queryKey: ["offer", offerId],
//                 queryFn: () => offerServices.getOfferById(offerId),
//                 enabled: !!offerId,
//                 staleTime: 5 * 60 * 1000,
//             }
//         ]
//     });
// };


import { useQueries } from '@tanstack/react-query';
import { offerServices } from 'features/offer/services/offer.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all offers
 */
export const useOffers = (params) => {
  return useQueries({
    queries: [
      {
        queryKey: ['offers', params],

        queryFn: async () => {
          try {
            return await offerServices.getOffers(
              params
            );
          } catch (error) {
            throw parseApiError(error);
          }
        },

        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes

        placeholderData: (previousData) =>
          previousData,

        retry: 1,
      },
    ],
  });
};

/**
 * Get single offer
 */
export const useOffer = (offerId) => {
  return useQueries({
    queries: [
      {
        queryKey: ['offer', offerId],

        queryFn: async () => {
          try {
            return await offerServices.getOfferById(
              offerId
            );
          } catch (error) {
            throw parseApiError(error);
          }
        },

        enabled: !!offerId,

        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes

        retry: 1,
      },
    ],
  });
};